import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PipeConfiguration } from 'app/models/pipe.model';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { APIService } from 'app/services/api.service';
import { MenuSection } from 'app/models/menu.model';
import { Organization } from 'app/models/organization.model';

@Component({
  selector: 'app-send-product-modal',
  templateUrl: './send-product-modal.component.html',
  styleUrls: ['./send-product-modal.component.scss']
})
export class SendProductModalComponent implements OnInit {
  dataSource: MatTableDataSource<TablePipeDataItem> =
    new MatTableDataSource<TablePipeDataItem>([]);
  tablePipeData: TablePipeDataItem[];
  columnsToDisplay =
    ['checkBox', 'organization', 'pipe'];
  loadingProduct: boolean;

  constructor(
    public dialogRef: MatDialogRef<SendProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendProductModalComponentData,
    private translate: TranslateService,
    private apiService: APIService,
  ) {
  }

  ngOnInit(): void {
    this.tablePipeData = this.data.pipes.map(p => ({
      pipe: p,
      checked: false,
      loading: false,
      startedLoading: false,
    }));
    this.dataSource = new MatTableDataSource(this.tablePipeData);
  }

  getColumnHeaderName(columnHeaderValue: string): string {
    switch (columnHeaderValue) {
      case 'pipe':
        return this.translate.instant('LOCATION.PIPE');
      case 'organization':
        return this.translate.instant('ORGANIZATION.NAME');
      default:
        return '';
    }
  }

  async uploadProduct(){
    for (let pipeData of this.tablePipeData) {

      if (!pipeData.checked){
        continue;
      }
      await this.apiService.SendProduct(
        pipeData.pipe.id,
        this.data.productId,
        this.data.organization.id,
        this.data.menuSection.name);
    }
  }
}

export interface SendProductModalComponentData{
  productId: string;
  menuSection: MenuSection;
  organization: Organization;
  pipes: PipeConfiguration[];
}


interface TablePipeDataItem{
  pipe: PipeConfiguration,
  checked: boolean,
  loading: boolean,
  startedLoading: boolean,
}
